import React from 'react';
import { Check } from 'lucide-react';

export default function ManualAction({ question, onChoiceClick }) {
  return (
    <div className="flex flex-col items-center gap-6 w-full max-w-2xl">
      <h2 className="text-2xl md:text-3xl font-semibold text-primary text-center min-h-[40px]">
        {question.ask}
      </h2>
      <button 
        onClick={() => onChoiceClick('Ожидает оценки врача')} 
        className="mt-4 flex items-center gap-2 px-8 py-4 bg-green-500/20 text-green-600 border-2 border-green-500 rounded-2xl font-semibold hover:bg-green-500/30 transition-colors"
      >
        <Check className="size-6" /> Пациент выполнил
      </button>
    </div>
  );
}